import { observer } from 'mobx-react-lite'

import { Breadcrumbs, Button, FullPageWrapper, Icon, Typography } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { SettingsRoutes } from 'pages/settings/route/type'
import { IntegrationsRoutes } from 'pages/settings/pages/integrations/route/type'
import { useWebhookIntegrationContext } from 'pages/settings/pages/integrations/layout/WebhookLayout'
import { WebhooksTable } from 'pages/settings/pages/integrations/pages/Webhooks/ui/WebhooksTable/WebhooksTable'
import styles from './styles.module.scss'

export const IntegrationWebhooks = observer(() => {
  const { integrationStore, webhooksStore } = useWebhookIntegrationContext()
  const { integration } = integrationStore

  if (!integration) return null

  return (
    <FullPageWrapper className={styles.container}>
      <div className={styles.content}>
        <Breadcrumbs customPath={`/${SettingsRoutes.root}/${IntegrationsRoutes.root}`} />
        <header>
          <Icon
            fontSize={26}
            icon={integration.icon}
            padding={11}
            insideBox
            className={styles.headerLogo}
          />
          <div className={styles.integrationsHeader}>
            <div className={styles.title}>
              <Typography variant='heading-lg' ariaLabel='IntegrationDetails_title'>
                {integration.name}
              </Typography>
            </div>
          </div>
          <div className={styles.actions}>
            <Button
              text='New webhook'
              typeBtn='outlined'
              iconProps={{ icon: 'add' }}
              size='medium'
              onClick={() =>
                uiStore.changeRoute({
                  path: `/${SettingsRoutes.root}/${IntegrationsRoutes.root}/${IntegrationsRoutes.webhooks}/${IntegrationsRoutes.create}`,
                })
              }
            />
          </div>
        </header>
        <div className={styles.tableContainer}>
          <WebhooksTable store={webhooksStore} />
        </div>
      </div>
    </FullPageWrapper>
  )
})
